// libs
import { useMutation } from '@apollo/client/react'
// graphql
import { RUN_STRATEGY_PROCESSES_BY_ACTION_MUTATION } from 'graphql/systemProcesses/mutations'
// types
import { SystemProcessActionType, SystemProcessObject } from 'types/graphql'

interface Params {
  entityId: string
  object: SystemProcessObject
  prev: number
  next: number | undefined
}

export const useStrategyCompletionProcess = () => {
  const [runStrategyProcessesByAction] = useMutation(RUN_STRATEGY_PROCESSES_BY_ACTION_MUTATION)

  return async ({ entityId, object, prev, next }: Params) => {
    if (prev < 100 && next === 100) {
      await runStrategyProcessesByAction({
        variables: { input: { entityId, object, actionType: SystemProcessActionType.Completed } }
      })
    } else if (prev === 100 && next < 100) {
      await runStrategyProcessesByAction({
        variables: { input: { entityId, object, actionType: SystemProcessActionType.Reopened } }
      })
    }
  }
}
